import React, { useState, useEffect } from 'react';
import './candidateDashboardSection.css';
import candidateDashboardImage from '../../../../assets/images/candidate_dashboard_section_image.png';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../../../homepage/registerflow/registerflow';
const CandidateDashboardSection = () => {
  const [activeSection, setActiveSection] = useState('default');
  const navigate = useNavigate();

  const handleJoinClick = () => {
    navigate('/login');
  };

  const sections = ['default', 'profile', 'value', 'users', 'pricing', 'pool'];

  let currentIndex = sections.indexOf(activeSection);

  const content = {
    default: {
      heading: 'Everything you need to elevate your career',
      paragraph: 'Navigate your leadership journey seamlessly with us',
    },
    profile: {
      heading: 'Assisted Profile Building',
      paragraph: 'Skip-filling lengthy profile forms. All you have to do is fill in your basic information and our consultants will contact you, create, and publish your profile.',
    },
    pool: {
      heading: 'Personalized Dashboards',
      paragraph: 'Gain in-depth insights into your profile with Leaderly’s distinct dashboard. Know the number of profile visits, searches for your role, companies hiring for the position, and sectors to which the companies belong to make informed decisions. ',
    },
    users: {
      heading: 'Self Assessment',
      paragraph: 'Take accredited online aptitude and psychometric tests. Assess your competencies and accelerate your career to empower your future.',
    },
    pricing: {
      heading: 'Online Counseling',
      paragraph: "Get mentored by the industry's top professionals and experts. Understand the industry trends, explore how to strengthen your competencies, and seek advice on career transition.",
    },
    value: {
      heading: 'Upskill Yourself',
      paragraph: 'Enhance your profile and skills with some of the best online course providers. We have collaborated with industry-leading learning platforms that will help you strengthen your leadership skills. ',
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection((prevSection) => {
        const currentIndex = sections.indexOf(prevSection);
        return sections[(currentIndex + 1) % sections.length];
      });
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };

  // const handleKnowMoreClick = () => {
  //   if (!sessionStorage.getItem("initialScrollPosition")) {
  //     sessionStorage.setItem("initialScrollPosition", window.scrollY);
  //   }
  //   sessionStorage.setItem("scrollPosition", window.scrollY);
  //   window.location.href = "/pricing-prelogin";
  // };

  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

  const openRegisterPopup = () => {
    setRegisterPopupVisible(true);
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };
  return (
    <div className='fluid-container'>
      <div className="dashboard-section-wrapper">
        <div className="dashboard-container">
          <div className="dashboard-background-lines"></div>
          <div className="dashboard-content">
            <div className="dashboard-text">
              <p className="dashboardsection-heading">{content[activeSection].heading}</p>
              <p className="dashboardsection-content">{content[activeSection].paragraph}</p>
            </div>
            <div className="dashboard-button-container">
              <button className="oval-button" onClick={openRegisterPopup}
              >
                Join Now
              </button>
            </div>
          </div>


          <div className="candidate-dashboard-links">
            {sections.slice(1).map((section) => (
              <a
                href="#"
                key={section}
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick(section);
                }}
                className={activeSection === section ? "active" : ""}
              >
                {content[section].heading}
              </a>
            ))}
          </div>

          <div className="dashboard-image">
            <img src={candidateDashboardImage} alt="Dashboard" />
          </div>
        </div>
      </div>
      <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
    </div>
  );
};

export default CandidateDashboardSection;